/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
import { customerPortalOrganizationsGet } from "../funcs/customerPortalOrganizationsGet.js";
import { ClientSDK } from "../lib/sdks.js";
import { unwrapAsync } from "../types/fp.js";
export class PolarOrganizations extends ClientSDK {
    /**
     * Get Organization
     *
     * @remarks
     * Get a customer portal's organization by slug.
     */
    async get(request, options) {
        return unwrapAsync(customerPortalOrganizationsGet(this, request, options));
    }
}
//# sourceMappingURL=polarorganizations.js.map